export enum Downloads {
  LINK_TREE = 1,
  AMAZON_WISHLIST = 2,
  JURIDIC_PERSON_GUIDE = 3,
  PHISICAL_PERSON_GUIDE = 4,
  ORCA_TUTORIAL = 5,
  IMPROVE_IG_PROFILE = 6
}
